<div class="folder-popup-backdrop" [class.folder-popup-backdrop--in-table]="mode === 'manage-folders'" (click)="close()"></div>
<div class="folder-popup"
     [class.folder-popup--in-table]="mode === 'manage-folders'"
     [class.folder-popup--create-folder]="mode === 'create-folder'"
     role="dialog"
     aria-modal="true"
     [attr.aria-label]="mode === 'manage-folders' ? 'Add rule to Folders' : mode === 'create-folder' ? 'Create new Folder' : (folder?.name + ' Folder')"
     cdkTrapFocus cdkTrapFocusAutoCapture
     [ngSwitch]="mode">

  <ng-container *ngSwitchCase="'manage-rules'">
    <header class="folder-popup-header">
      <i class="material-icons-outlined notranslate folder-popup-folder-icon"
         [style.color]="folder?.colour">folder</i>

      <span class="folder-popup-title">
        <ng-container *ngIf="isRenaming; else titleView">
          <span class="folder-popup-rename-wrapper">
            <input class="folder-popup-rename-input"
                   placeholder="Press Esc to cancel"
                   [value]="renameValue"
                   (input)="onRenameInput($any($event.target).value)"
                   (keydown.enter)="submitRename($event)"
                   (keydown.escape)="cancelRename($event)"
                   #renameInput />
            <button class="return-icon"
                    type="button"
                    aria-label="Submit rename"
                    [disabled]="!renameValue.trim() || renameValue.trim() === folder?.name || folderNameAlreadyExists"
                    (mousedown)="$event.preventDefault()"
                    (click)="submitRename()"
                    matTooltip="Hit 'Enter' to complete"
                    matTooltipPosition="below"
                    [matTooltipShowDelay]="500"></button>
          </span>
        </ng-container>
        <ng-template #titleView>
          <span class="folder-popup-title-text"
                [matTooltip]="folder?.name"
                [matTooltipShowDelay]="500"
                matTooltipPosition="below"
                (click)="enableRenaming()">{{folder?.name}}</span>
          <button class="folder-popup-action-btn folder-popup-action-btn--edit"
                  matTooltip="Rename folder"
                  matTooltipPosition="below"
                  [matTooltipShowDelay]="500"
                  type="button"
                  (click)="enableRenaming()">
            <i class="material-icons notranslate">edit</i>
          </button>
        </ng-template>
      </span>

      <div class="folder-popup-header-actions">
        <button class="folder-popup-action-btn folder-popup-action-btn--delete"
                [matTooltip]="'Delete ' + folder?.name + ' folder'"
                matTooltipPosition="below"
                [matTooltipShowDelay]="500"
                type="button"
                (click)="deleteRequested.emit()">
          <i class="material-icons-outlined notranslate">delete</i>
        </button>

        <button class="folder-popup-action-btn folder-popup-action-btn--close"
                matTooltip="Close"
                matTooltipPosition="below"
                [matTooltipShowDelay]="500"
                type="button"
                aria-label="Close popup"
                (click)="close()">
          <i class="material-icons-outlined notranslate">close</i>
        </button>
      </div>
    </header>

    <p class="folder-popup-empty folder-popup-empty--error" *ngIf="isRenaming && folderNameAlreadyExists" @appearFromAbove>
      <i class="material-icons-outlined notranslate">error_outline</i>
      A Folder with that name already exists
    </p>

    <app-rule-search-autocomplete
      [options]="allRules"
      [existingIds]="folderRuleIds"
      (optionSelected)="onRuleSearchSelected($event)"
      (closeRequested)="close()">
    </app-rule-search-autocomplete>

    <ul class="folder-popup-list" *ngIf="folderRules.length > 0; else emptyRules">
      <li *ngFor="let rule of folderRules" class="folder-popup-row">
        <i [class]="rule.iconClass + ' folder-popup-row-icon'"></i>
        <span class="folder-popup-row-label"
              [matTooltip]="rule.name"
              [matTooltipShowDelay]="500"
              matTooltipPosition="below">{{rule.name}}</span>
        <button class="folder-popup-row-remove"
                matTooltip="Remove Rule from folder"
                matTooltipPosition="right"
                [matTooltipShowDelay]="500"
                type="button"
                aria-label="Remove rule from folder"
                (click)="removeRule(rule, $event)">
          <i class="material-icons-outlined notranslate">close</i>
        </button>
      </li>
    </ul>

    <ng-template #emptyRules>
      <p class="folder-popup-empty">
        No Rules in this Folder yet.<br>
        Search above to add some
      </p>
    </ng-template>
  </ng-container>

  <ng-container *ngSwitchCase="'create-folder'">
    <header class="folder-popup-header">
      <i class="material-icons-outlined notranslate folder-popup-folder-icon">create_new_folder</i>

      <span class="folder-popup-title">
        <span class="folder-popup-rename-wrapper">
          <input class="folder-popup-rename-input"
                 placeholder="New Folder name..."
                 [formControl]="createFolderControl"
                 (input)="onCreateFolderInput()"
                 (keydown.enter)="submitCreateFolder($event)"
                 (keydown.escape)="cancelCreate($event)"
                 #createFolderInput />
          <button class="return-icon"
                  type="button"
                  aria-label="Create Folder"
                  [disabled]="!createFolderControl.value?.trim() || folderNameAlreadyExists"
                  (mousedown)="$event.preventDefault()"
                  (click)="submitCreateFolder()"
                  matTooltip="Create Folder (Enter)"
                  matTooltipPosition="below"
                  [matTooltipShowDelay]="500"></button>
        </span>
      </span>

      <div class="folder-popup-header-actions">
        <button class="folder-popup-action-btn folder-popup-action-btn--close"
                matTooltip="Close"
                matTooltipPosition="below"
                [matTooltipShowDelay]="500"
                type="button"
                aria-label="Close popup"
                (click)="close()">
          <i class="material-icons-outlined notranslate">close</i>
        </button>
      </div>
    </header>

    <p class="folder-popup-empty folder-popup-empty--error" *ngIf="folderNameAlreadyExists" @appearFromAbove>
      <i class="material-icons-outlined notranslate">error_outline</i>
      A Folder with that name already exists
    </p>
    <p class="folder-popup-empty">
      Type a name and press Enter<br>to create a new Folder
    </p>
  </ng-container>

  <ng-container *ngSwitchCase="'manage-folders'">
    <header class="folder-popup-header">
      <i class="material-icons-outlined notranslate folder-popup-folder-icon">create_new_folder</i>

      <span class="folder-popup-title">
        <span class="folder-popup-title-text">Add Rule to Folders</span>
      </span>

      <div class="folder-popup-header-actions">
        <button *ngIf="showArchiveInSearch"
                class="folder-popup-action-btn folder-popup-action-btn--archive"
                matTooltip="Archive Rule"
                matTooltipPosition="below"
                [matTooltipShowDelay]="500"
                type="button"
                aria-label="Archive rule"
                (click)="archiveRequested.emit()">
          <i class="material-icons-outlined notranslate">inventory_2</i>
        </button>
        <button class="folder-popup-action-btn folder-popup-action-btn--close"
                matTooltip="Close"
                matTooltipPosition="below"
                [matTooltipShowDelay]="500"
                type="button"
                aria-label="Close popup"
                (click)="close()">
          <i class="material-icons-outlined notranslate">close</i>
        </button>
      </div>
    </header>

    <app-folder-autocomplete
      [staticOptions]="availableFolders"
      [showArchive]="showArchiveInSearch"
      [existingNames]="allFolderNames"
      [reservedFolderNames]="reservedFolderNames"
      [allowCreate]="true"
      placeholder="Search Folders (or add new)..."
      (folderSelected)="onFolderSearchSelected($event)"
      (folderCreated)="folderCreated.emit($event)"
      (searchChanged)="onFolderSearchChanged($event)"
      (closeRequested)="close()">
    </app-folder-autocomplete>

    @if (folderNameAlreadyExists) {
      <p class="folder-popup-empty folder-popup-empty--error" @appearFromAbove>
        <i class="material-icons-outlined notranslate">error_outline</i>
        A Folder with that name already exists
      </p>
    }

    <ul class="folder-popup-list" *ngIf="ruleFolderOptions.length > 0; else emptyFolders">
      <li *ngFor="let folder of ruleFolderOptions"
          class="folder-popup-row"
          [class.folder-popup-row--archived]="folder.id === 'archive'">
        <i [class]="(folder.outlinedIcon ? 'material-icons-outlined' : 'material-icons') + ' notranslate folder-popup-row-icon'"
           [style.color]="folder.colour">{{folder.icon}}</i>
        <span class="folder-popup-row-label"
              [matTooltip]="folder.id === 'archive' ? 'This Rule has been Archived' : folder.name"
              [matTooltipShowDelay]="500"
              matTooltipPosition="below">{{folder.id === 'archive' ? 'This Rule has been Archived' : folder.name}}</span>
        <button class="folder-popup-row-remove"
                [matTooltip]="folder.id === 'archive' ? 'Unarchive Rule' : 'Remove Rule from ' + folder.name"
                matTooltipPosition="right"
                [matTooltipShowDelay]="500"
                type="button"
                [attr.aria-label]="folder.id === 'archive' ? 'Unarchive rule' : 'Remove rule from ' + folder.name"
                (click)="removeFolder(folder, $event)">
          <i class="material-icons-outlined notranslate">{{folder.id === 'archive' ? 'unarchive' : 'close'}}</i>
        </button>
      </li>
    </ul>

    <ng-template #emptyFolders>
      <p class="folder-popup-empty">This rule isn't in any folders yet.<br>Search above to add one</p>
    </ng-template>
  </ng-container>

</div>
